import { style } from 'typestyle'
export const pl12 = style({ paddingLeft: '12px' })
